import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_user/my-coaching/clients/programs")({
  staticData: { title: "Client programs" },
  // Every coach works here from the day she registers, including one under
  // review. A revoked coach goes to the dashboard, which shows her revoked
  // access.
  beforeLoad: ({ context }) => {
    if (context.isRevoked) {
      throw redirect({ to: "/my-coaching/clients/dashboard" });
    }
  },
  component: ClientsLayout,
});

function ClientsLayout() {
  return <Outlet />;
}
